const X_ACCOUNT = 'rinsho_nurselab';

export default function Footer({ setCurrentPage }) {
  const navItems = [
    { label: 'ホーム', page: 'home' },
    { label: 'ツール一覧', page: 'tools' },
    { label: '記事一覧', page: 'articles' },
    { label: 'プロフィール', page: 'profile' },
    { label: 'プライバシーポリシー・免責事項', page: 'privacy' },
  ];

  return (
    <footer className="bg-green-900 text-green-100 mt-20 no-print">
      <div className="max-w-5xl mx-auto px-4 py-10 text-center">
        <div className="flex items-center justify-center gap-2 text-white font-bold text-lg mb-2">
          臨床ナースラボ
        </div>
        <p className="text-sm text-green-300">現場の看護師による、看護師のための知識とツールのサイト</p>

        <nav className="mt-6 flex flex-wrap justify-center gap-x-5 gap-y-2">
          {navItems.map((item) => (
            <button
              key={item.page}
              onClick={() => setCurrentPage(item.page)}
              className="text-xs text-green-200 hover:text-white hover:underline transition-colors"
            >
              {item.label}
            </button>
          ))}
          <a
            href={`https://x.com/${X_ACCOUNT}`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-xs text-green-200 hover:text-white hover:underline transition-colors"
          >
            X（@{X_ACCOUNT}）
          </a>
        </nav>

        <p className="text-xs text-green-400 mt-6">
          ※ 本サイトのツールは医療診断を目的としたものではありません。臨床判断の補助としてご活用ください。
        </p>
        <p className="text-xs text-green-500 mt-4">当サイトはAmazonアソシエイト・プログラムに参加しています。</p>
        <p className="text-xs text-green-700 mt-2">© 2026 臨床ナースラボ</p>
      </div>
    </footer>
  );
}
